import _get from 'lodash/get'
import { baseRequest } from '.'

export const getInfluencerReferrersData = async id => {
  const res = await baseRequest.get(`/events/${id}/relationships/referrals/`)
  return _get(res, 'data.data', {})
}